import type { GameState, TileState } from '../types';
import { COLS } from '../game/constants';

export type KeyInput = 'ENTER' | 'BACK' | string;

const KB_LAYOUT: readonly (readonly string[])[] = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
  ['ENTER', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'BACK'],
];

const RANK: Record<TileState, number> = { absent: 0, present: 1, correct: 2 };

export function buildKeyboard(root: HTMLElement, onKey: (k: KeyInput) => void): void {
  root.innerHTML = '';
  for (const row of KB_LAYOUT) {
    const rowEl = document.createElement('div');
    rowEl.className = 'kb-row';
    for (const k of row) {
      const btn = document.createElement('button');
      btn.className = 'key' + (k.length > 1 ? ' wide' : '') + (k === 'BACK' ? ' key-back' : '');
      btn.textContent = k === 'BACK' ? '⌫' : k;
      btn.dataset['key'] = k;
      btn.addEventListener('click', () => onKey(k));
      rowEl.appendChild(btn);
    }
    root.appendChild(rowEl);
  }
}

export function renderKeyboard(root: HTMLElement, state: GameState): void {
  // Visually and functionally disable the on-screen keyboard once the game is
  // over. The DOM `disabled` attribute matters — without it click events fire
  // even on a greyed-out button.
  const isOver = state.status !== 'playing';
  root.classList.toggle('disabled', isOver);

  const best: Record<string, TileState> = {};
  for (const g of state.guesses) {
    for (let i = 0; i < COLS; i++) {
      const ch = g.word[i];
      const r = g.results[i];
      if (ch === undefined || r === undefined) continue;
      const prev = best[ch];
      if (prev === undefined || RANK[r] > RANK[prev]) best[ch] = r;
    }
  }
  for (const btn of root.querySelectorAll<HTMLButtonElement>('.key')) {
    btn.disabled = isOver;
    const k = btn.dataset['key'];
    if (k && k.length === 1) {
      const tone = best[k];
      if (tone) {
        btn.classList.remove('correct', 'present', 'absent');
        btn.classList.add(tone);
      }
    }
  }
}
